import { render, staticRenderFns } from "./logic.vue?vue&type=template&id=30921111"
import script from "./logic.vue?vue&type=script&lang=js"
export * from "./logic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports